module.exports = __webpack_public_path__ + "media/img/uploads/program-office-corona-fire-6135eb36694158524a788eb86fef01f0.jpg";